import React,{useState} from "react";
import { DATE_FORMAT4 } from "../../../constants/stringConstants";
import { useAddCertificateMutation, useEditCertificateMutation } from "../../../store/profileSlice";
import { useAppSelector } from "../../../store/store";
import ModalContainer from "../../ModalContainer";
import ModalDatePicker from "../../ModalDatePicker"; 
import ModalInputField from "../../ModalInputField"; 
import moment from "moment";
import { isEmpty } from "lodash";
import HeaderModalText from "../../HeaderModalText";
import PdfUploadingComponent from "../../PdfUploadingComponent";


function CourseModal({editData,isVisible,onClose}) {
    const [input, setInput] = useState({ 
      certificateName: editData?.nameOfCertificate??"",
        institute:editData?.institute?? "",
        startDate: editData?.from??"", 
        endDate:editData?.to?? "", 
      });

      const [error, setError] = useState({ 
        certificateName: "",
          institute: "",
          startDate: "",
          endDate: "",
        });
const[loading,setLoading]=useState(false)
      const { user } = useAppSelector((state) => state["user"]);
      const [addCertificate] =
      useAddCertificateMutation();
      const [editCertificate] =
      useEditCertificateMutation();
      const [imageFile, setImageFile] = useState(editData?.certificateImage??"");


const onChangeText = (event) => {
    
    setInput({
      ...input, 
      [event.target.name]: event.target.value,
    }); 
  };

  

  const onChangeStartDate=(date)=>{
    setInput({ ...input, startDate: `${date}` });
  }

  const onChangeEndDate=(date)=>{
    setInput({ ...input, endDate: `${date}` });
  }


  const errorSec = (err) => (
    <div style={{ marginBottom: "20px" }}>
      <text style={{ color: "red" }}>{err}</text>
    </div>
  );

  
const validation=()=>{

  const{ 
    certificateName,
    institute,
    startDate,
    endDate}=input
   
  let valid = true;
  let certificateNameError = "";
  let instituteError = "";
  let startDateError = "";
  let endDateError = "";
  
  
  if (isEmpty(certificateName)) {
    valid = false;
    certificateNameError = "Certificate title cannot be empty";
  }
  
  if (isEmpty(institute)) {
    valid = false;
    instituteError = "Institute name cannot be empty";
  } 
  
  if (isEmpty(startDate)) {
    valid = false;
    startDateError = "You need to select a start date";
  }
  
  
  if(isEmpty(endDate) ){
    valid = false;
    endDateError = "You need to select an end date";
  }
  
  
  setError({
    ...error,
     certificateName: certificateNameError,
    institute: instituteError,
    startDate:startDateError,
    endDate:endDateError,
  });
  
  return valid;
  };


  const addEditCourse=()=>{
    if(validation()){
      setLoading(true)
 let courseData={
  nameOfCertificate:input.certificateName,
  institute:input.institute,
  from:moment(input.startDate).format(DATE_FORMAT4),
  to:moment(input.endDate).format(DATE_FORMAT4),
  certificateImage:imageFile
 }

 
let payload={}

//add course
if(isEmpty(editData)){
 payload={
param:user?.id??'',
data:[courseData]
}


    addCertificate(payload)
      .unwrap()
      .then((incomingData) => {
        setLoading(false)
        
        onClose()
      })
      .catch((err) => {
        setLoading(false)
        console.log(err);
      });

    }

    //edit course

    else{
      payload={
        param:editData?.id??'',
        data:courseData
        }
      editCertificate(payload)
      .unwrap()
      .then((incomingData) => {
        setLoading(false)
        
        onClose()
      })
      .catch((err) => {
        setLoading(false)
        console.log(err);
      });

    }
  }
  }

  return (
<ModalContainer onClose={onClose} onBtnClick={addEditCourse} isVisible={isVisible}
modalHeaderText={"Profile"}
modalSubHeaderText={isEmpty(editData)?"Add Course":"Edit Course"}
isLoading={loading}
>
    
<div style={{marginBottom:'2rem'}}>   
<ModalInputField isRequired={true} name={'certificateName'} headerText={'Certificate Name'} onChangeText={onChangeText} inputFieldValue={input.certificateName} hasError={!isEmpty(error.certificateName)}/>
{!isEmpty(error.certificateName) && errorSec(error.certificateName)}

</div>

    <div style={{marginBottom:'2rem'}}>   
<ModalInputField isRequired={true} name={'institute'} headerText={'Institute'} onChangeText={onChangeText} inputFieldValue={input.institute} hasError={!isEmpty(error.institute)}/>
{!isEmpty(error.institute) && errorSec(error.institute)}

</div>

<div style={{marginBottom:'2rem'}}>   
<ModalDatePicker isRequired={true} headerText={"Start Date"} handleChangeDate={onChangeStartDate} dateValue={input.startDate} hasError={!isEmpty(error.startDate)}/>
{!isEmpty(error.startDate) && errorSec(error.startDate)}

</div>   

<div style={{marginBottom:'2rem'}}>   
<ModalDatePicker isRequired={true} headerText={"End Date"} handleChangeDate={onChangeEndDate} dateValue={input.endDate} hasError={!isEmpty(error.endDate)}/>
{!isEmpty(error.endDate) && errorSec(error.endDate)}

</div>   


    <div style={{flexDirection:'column',flex:1,display:'flex'}} >
  <HeaderModalText text={"Certificate Document"}/>
  <PdfUploadingComponent imageFile={imageFile} setFile={setImageFile}/>


</div> 



</ModalContainer>


);
}

export default CourseModal;
